import { useMemo } from 'react';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { useDropEvent, useUserCampaignData } from 'root/src/client/logic/dropEvent/hooks/useDropEvent';
import { useViewershipPlatformsByDares } from 'root/src/client/logic/dropEvent/hooks/useViewershipPlatformsByDares';
import { calculateMaxDaresByPlatform } from 'root/src/shared/util/calculateMaxDares';
// How many dares the requesting creator has left on each of the drop's viewership platforms.
// `fallbackDrop` follows the same pattern as useMaxDaresByPlatforms/useViewershipPlatformsByDares: the
// redesign drop page loads the drop over tRPC and never fills the redux record useDropEvent reads, and it
// has no userCampaignData record either, so the accepted-dares count comes off the drop payload instead.
// The legacy DaresLeft chip keeps its own inline copy of this calculation so the two stay independent
// while both designs are live; this hook is what the redesign badge uses.
export const useDaresLeftPerPlatform = ({ fallbackDrop } = {}) => {
    var _a, _b;
    const { averageCcv = 0, averageTikTokViews = 0, averageYoutubeViews = 0, averageYoutubeShortsViews = 0 } = useUserCreatorData();
    const dropEvent = (_a = useDropEvent()) !== null && _a !== void 0 ? _a : fallbackDrop;
    const userCampaignData = useUserCampaignData(dropEvent === null || dropEvent === void 0 ? void 0 : dropEvent.mnemonicId);
    const { viewershipPlatformsByDares } = useViewershipPlatformsByDares(undefined, fallbackDrop);
    const acceptedByPlatform = (_b = userCampaignData === null || userCampaignData === void 0 ? void 0 : userCampaignData.creatorAcceptedDaresByPlatform) !== null && _b !== void 0 ? _b : dropEvent === null || dropEvent === void 0 ? void 0 : dropEvent.creatorAcceptedDaresByPlatform;
    return useMemo(() => {
        if (!dropEvent) {
            return [];
        }
        return viewershipPlatformsByDares.map((platform) => {
            const maxDares = calculateMaxDaresByPlatform({
                averageCcv,
                averageYoutubeViews,
                averageYoutubeShortsViews,
                averageTikTokViews,
                platform,
                campaign: dropEvent,
            });
            return {
                platform,
                left: dropEvent.isAbleToParticipate
                    ? Math.max(0, maxDares - ((acceptedByPlatform === null || acceptedByPlatform === void 0 ? void 0 : acceptedByPlatform[platform]) || 0))
                    : 0,
            };
        });
    }, [dropEvent, acceptedByPlatform, averageCcv, averageYoutubeViews, averageYoutubeShortsViews, averageTikTokViews, viewershipPlatformsByDares]);
};
